var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import Datetime from 'react-datetime';
import PropTypes from 'prop-types';
import 'moment/locale/ru';
import 'moment/locale/en-gb';
import 'moment/locale/uz-latn';
import 'moment/locale/kk';
import { getMomentLocale } from '../../shared/momentLocale';
var DateRange = function (props) {
    var locale = getMomentLocale(props.languageId);
    return [
        _jsx("div", __assign({ className: 'datapicker from' }, { children: _jsx(Datetime, { timeFormat: false, className: 'calendar', locale: locale, inputProps: { readOnly: true }, closeOnSelect: true, onChange: props.startDateChange }) }), 'startDate'),
        _jsx("div", __assign({ className: 'datapicker to' }, { children: _jsx(Datetime, { timeFormat: false, className: 'calendar', locale: locale, inputProps: { readOnly: true }, closeOnSelect: true, onChange: props.endDateChange }, 'endDate') }), 'endDate')
    ];
};
DateRange.propTypes = {
    startDateChange: PropTypes.func.isRequired,
    endDateChange: PropTypes.func.isRequired,
    languageId: PropTypes.any
};
export default DateRange;



// WEBPACK FOOTER //
// ./src/components/shared/DateRange.jsx